import React from "react";
import leftArrow from "../images/icon-previous.svg";
import rightArrow from "../images/icon-next.svg";
import closeIcon from "../images/icon-close.svg";

const ImageModal = ({
    isOpen,
    image,
    onClose,
    images,
    smallImages,
    setImage,
}) => {
    if (!isOpen) return null;

    const handlePrevious = () => {
        const currentIndex = images.indexOf(image);
        const previousIndex =
            (currentIndex - 1 + images.length) % images.length;
        setImage(images[previousIndex]);
    };

    const handleNext = () => {
        const currentIndex = images.indexOf(image);
        const nextIndex = (currentIndex + 1) % images.length;
        setImage(images[nextIndex]);
    };

    const handleSmallImageClick = (index) => {
        setImage(images[index]);
    };

    return (
        <div className="absolute inset-0 flex items-center justify-center flex-col bg-black bg-opacity-75 z-50">
            <div className="relative">
                <button
                    onClick={onClose}
                    className="absolute top-[-30px] right-0 "
                >
                    <img
                        src={closeIcon}
                        alt="close"
                        className="hover:text-[#FF7E1B] transition duration-300 ease-in-out"
                    />
                </button>
                <button
                    onClick={handlePrevious}
                    className="absolute left-[-28px] top-1/2 transform -translate-y-1/2 bg-white rounded-full w-[56px] h-[56px] flex items-center justify-center"
                >
                    <img
                        src={leftArrow}
                        alt="previous"
                        className="hover:text-[#FF7E1B] transition duration-300 ease-in-out"
                    />
                </button>
                <button
                    onClick={handleNext}
                    className="absolute right-[-28px] top-1/2 transform -translate-y-1/2 bg-white rounded-full w-[56px] h-[56px] flex items-center justify-center"
                >
                    <img
                        src={rightArrow}
                        alt="next"
                        className="transition duration-300 ease-in-out"
                    />
                </button>
                <img
                    src={image}
                    alt="product"
                    className="w-[550px] h-auto rounded-[15px]"
                />
            </div>
            <div className="flex w-full gap-8 justify-center mt-10 max-w-[550px]">
                {smallImages.map((smallImage, index) => (
                    <div
                        key={index}
                        className="relative cursor-pointer group"
                        onClick={() => handleSmallImageClick(index)}
                    >
                        <img
                            src={smallImage}
                            alt="product"
                            className="max-w-[88px] rounded-[10px]"
                        />
                        {images.indexOf(image) === index && (
                            <div className="absolute inset-0 bg-white opacity-75 rounded-[10px] border-2 border-[#FF7E1B]"></div>
                        )}
                        {images.indexOf(image) !== index && (
                            <div className="absolute inset-0 bg-white opacity-0 rounded-[10px] group-hover:opacity-50 transition-opacity hover:cursor-pointer"></div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageModal;
